import React from 'react';
import PubSub from 'pubsub-js';

import events from './events';

class GoogleAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.sendPageView = this.sendPageView.bind(this);
  }

  componentDidMount() {
    const { history, location } = this.props;

    this.sendPageView(location);
    history.listen(this.sendPageView);

    events.forEach(topic =>
      PubSub.subscribe(topic, message => {
        if (!window.ga) {
          return;
        }

        const [category, action] = message.split('.');

        if (category && action) {
          window.ga('send', 'event', category, action);
        }
      })
    );
  }

  sendPageView(location) {
    if (!window.ga) {
      return;
    }

    const { debug } = this.props;

    window.ga('set', 'page', location.pathname);
    window.ga('send', 'pageview');

    if (debug) {
      console.info(`[react-router-ga] Page view: ${location.pathname}`);
    }
  }

  render() {
    const { children } = this.props;

    return children;
  }
}

export default GoogleAnalytics;
